import React from 'react';
import PropTypes from 'prop-types';
import { WithIconRounded } from 'Components/ProfileMultiProduct/components/designSystem';

const IconIcon = ({
  className,
  color,
  containerColor,
  containerSize,
  disabled,
  onClick,
  round,
  size,
}) => (
  <WithIconRounded
    round={round}
    containerColor={containerColor}
    containerSize={containerSize}
    className={className}
    onClick={onClick}
  >
    <svg
      aria-label="copy-icon"
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.66732 3.66683V1.00016C3.66732 0.823352 3.73756 0.653782 3.86258 0.528758C3.9876 0.403734 4.15717 0.333496 4.33398 0.333496H13.0007C13.1775 0.333496 13.347 0.403734 13.4721 0.528758C13.5971 0.653782 13.6673 0.823352 13.6673 1.00016V9.66683C13.6673 9.84364 13.5971 10.0132 13.4721 10.1382C13.347 10.2633 13.1775 10.3335 13.0007 10.3335H10.334V12.9955C10.334 13.3662 10.0347 13.6668 9.66265 13.6668H1.00532C0.917133 13.6669 0.829796 13.6496 0.748306 13.6159C0.666817 13.5822 0.592775 13.5328 0.530418 13.4704C0.468062 13.408 0.418615 13.334 0.384908 13.2525C0.351202 13.171 0.333897 13.0837 0.333985 12.9955L0.335985 4.33816C0.335985 3.9675 0.635318 3.66683 1.00732 3.66683H3.66732ZM5.00065 3.66683H9.66265C10.0333 3.66683 10.334 3.96616 10.334 4.33816V9.00016H12.334V1.66683H5.00065V3.66683ZM1.66932 5.00016L1.66732 12.3335H9.00065V5.00016H1.66932Z"
        fill={disabled ? 'var(--k-ds-color-disabled)' : color}
      />
    </svg>
  </WithIconRounded>
);

IconIcon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  containerColor: PropTypes.string,
  containerSize: PropTypes.number,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  round: PropTypes.bool,
  size: PropTypes.number,
};

IconIcon.defaultProps = {
  className: 'k-ds-bg-color-light-grey-300',
  color: 'var(--k-ds-color-interactive-primary)',
  containerColor: null,
  containerSize: 40,
  disabled: false,
  onClick: null,
  round: false,
  size: 14,
};

export default IconIcon;
